import { useNavigate } from "react-router-dom";
import { Paper } from "@mui/material";

import Page from "./Page";
import useRepDashboard from "../../hooks/useRepDashboard";
import Loading from "../ui/Loading";

import RepDashboardFilters from "../dashboard/RepDashboardFilters";
import CompletionByRepTable from "../dashboard/CompletionByRepTable";

const RepDashboard = () => {
  const navigate = useNavigate();
  const { filters, updateFilters, completionByRep, isLoading } =
    useRepDashboard();

  const handleFilterChange = (newFilters) => {
    updateFilters(newFilters);
  };

  const handleToolBarClick = (item) => {
    switch (item) {
      case "callDashboard":
        navigate("/home");
        break;

      case "syncDashboard":
        navigate("/syncdashboard");
        break;

      case "surveyDashboard":
        navigate("/surveymetrics");
        break;

      case "orderDashboard":
        navigate("/orderdashboard");
        break;

      case "clientDashboard":
        navigate("/clientdashboard");
        break;

      default:
        break;
    }
  };

  if (isLoading && !completionByRep.data) {
    return <Loading />;
  }

  return (
    <Page
      pageName="repDashboard"
      includeToolbar={true}
      onToolItemClick={handleToolBarClick}
      items={[
        { name: "callDashboard", iconName: "CalendarMonth" },
        { name: "syncDashboard", iconName: "CloudSync" },
        { name: "surveyDashboard", iconName: "Assignment" },
        { name: "orderDashboard", iconName: "ShoppingCart" },
        { name: "clientDashboard", iconName: "Business" },
      ]}
    >
      <Paper sx={{ p: 2, mb: 3 }}>
        <RepDashboardFilters
          filters={filters}
          onChange={handleFilterChange}
        />
      </Paper>

      <CompletionByRepTable
        data={completionByRep.data}
        isLoading={completionByRep.isLoading}
        error={completionByRep.error}
        filters={filters}
      />
    </Page>
  );
};

export default RepDashboard;
